import Block from 'quill/blots/block';
import Text from 'quill/blots/text';
import type Quill from 'quill/core';

const SAMPLE_COUNT = 10;
const CAPITAL_LETTER_REGEX = /[A-Z]/;

const getSampleWords = (quill: Quill) => {
  const lines = quill.getLines();
  const sampleWords: string[] = [];

  // eslint-disable-next-line no-restricted-syntax
  for (const line of lines) {
    if (line instanceof Block) {
      const texts = line.descendants(Text);
      // eslint-disable-next-line no-restricted-syntax
      for (const text of texts) {
        const words = text
          .value()
          .split(/[\s.?!,:;"'()]/)
          .filter((v) => v.length > 1);
        // eslint-disable-next-line no-restricted-syntax
        for (const word of words) {
          if (!CAPITAL_LETTER_REGEX.test(word)) {
            sampleWords.push(word);
            if (sampleWords.length >= SAMPLE_COUNT) {
              return sampleWords;
            }
          }
        }
      }
    }
  }
  return null;
};

export default getSampleWords;
